/**
 * Три прыгающие точки — «идёт генерация».
 *
 * Разметка была скопирована в ShadowColumn и HeroSection: одинаковые
 * задержки анимации, одинаковые размеры. Менять пришлось бы в обоих.
 */

interface TypingDotsProps {
  /** Класс цвета точек, по умолчанию акцент ассистента */
  className?: string;
}

const DELAYS = ['[animation-delay:0ms]', '[animation-delay:150ms]', '[animation-delay:300ms]'];

export function TypingDots({ className = 'bg-accent-ai' }: TypingDotsProps): JSX.Element {
  return (
    <div className="flex gap-0.5 ml-1">
      {DELAYS.map(delay => (
        <span
          key={delay}
          className={`w-1.5 h-1.5 rounded-full animate-bounce ${delay} ${className}`}
        />
      ))}
    </div>
  );
}
